/**
 * Horizontal Accordions: one panel active (wider), click to switch.
 * Desktop only: tablist/tab behavior and click to expand. Mobile: static list, no JS interactivity.
 */

const ACCORDION_MEDIA = window.matchMedia('(min-width: 1120px)');

class HorizontalAccordions {
	constructor(el) {
		if (!el) return;
		this.grid = el;
		this.panels = [...this.grid.querySelectorAll(':scope > .wp-block-embark-horizontal-accordion')];
		if (!this.panels.length && this.grid.children.length) {
			this.panels = [...this.grid.children].filter((c) => c.querySelector('.wp-block-embark-horizontal-accordion__inner'));
		}
		if (!this.panels.length) return;

		this.grid.setAttribute('data-count', String(this.panels.length));

		if (ACCORDION_MEDIA.matches) {
			this.enableAccordion();
		}
		ACCORDION_MEDIA.addEventListener('change', (e) => {
			if (e.matches) this.enableAccordion();
			else this.disableAccordion();
		});
	}

	enableAccordion() {
		const raw = parseInt(this.grid.getAttribute('data-default-open') || '1', 10);
		const zeroBased = raw >= 1 ? raw - 1 : 0;
		this.currentIndex = Math.min(zeroBased, this.panels.length - 1);

		this.panels.forEach((panel, i) => {
			panel.style.transition = 'none';
			panel.setAttribute('role', 'tab');
			panel.setAttribute('aria-selected', i === this.currentIndex ? 'true' : 'false');
			panel.setAttribute('tabindex', i === this.currentIndex ? '0' : '-1');
			panel.classList.toggle('active', i === this.currentIndex);

			panel.addEventListener('click', this.boundClick || (this.boundClick = (e) => {
				const target = e.target.closest('.wp-block-embark-horizontal-accordion');
				if (!target) return;
				let index = this.panels.indexOf(target);
				if (index < 0) index = this.panels.findIndex((p) => p.contains(target));
				if (index >= 0) this.open(index, true);
			}));
			panel.addEventListener('keydown', this.boundKeydown || (this.boundKeydown = (e) => {
				const i = this.panels.indexOf(e.currentTarget);
				if (i >= 0) this.handleKeydown(e, i);
			}));
		});

		this.grid.classList.add('js-init');

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				this.panels.forEach((p) => { p.style.transition = ''; });
			});
		});
	}

	disableAccordion() {
		this.panels.forEach((panel) => {
			panel.removeAttribute('role');
			panel.removeAttribute('aria-selected');
			panel.removeAttribute('tabindex');
			panel.classList.remove('active');
			if (this.boundClick) panel.removeEventListener('click', this.boundClick);
			if (this.boundKeydown) panel.removeEventListener('keydown', this.boundKeydown);
		});
	}

	open(index, fromClick = false) {
		if (index < 0 || index >= this.panels.length || index === this.currentIndex) return;

		this.panels[this.currentIndex].classList.remove('active', 'animate-in');
		this.panels[this.currentIndex].setAttribute('aria-selected', 'false');
		this.panels[this.currentIndex].setAttribute('tabindex', '-1');

		this.currentIndex = index;

		this.panels[this.currentIndex].classList.add('active', 'animate-in');
		this.panels[this.currentIndex].setAttribute('aria-selected', 'true');
		this.panels[this.currentIndex].setAttribute('tabindex', '0');
		if (!fromClick) {
			this.panels[this.currentIndex].focus({ preventScroll: true });
		}
	}

	handleKeydown(e, index) {
		let handled = false;
		switch (e.key) {
			case 'ArrowLeft':
			case 'ArrowUp':
				this.open(index - 1);
				handled = true;
				break;
			case 'ArrowRight':
			case 'ArrowDown':
				this.open(index + 1);
				handled = true;
				break;
			case 'Home':
				this.open(0);
				handled = true;
				break;
			case 'End':
				this.open(this.panels.length - 1);
				handled = true;
				break;
			default:
				break;
		}
		if (handled) {
			e.preventDefault();
			e.stopPropagation();
		}
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const grids = [...document.querySelectorAll('.wp-block-embark-horizontal-accordions__grid')];
	grids.forEach((el) => new HorizontalAccordions(el));
});
